var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '../Button/button.element';
import Modal from '../Modal';
import CreateRuleDialog from '../../containers/DatasetRulesPage/CreateRuleDialog';
import Select from '@project/components/Forms/Fields/ReusableSelect';
import IconPopover from '../IconPopover';
import { faQuestion } from '@fortawesome/pro-solid-svg-icons/faQuestion';
import { defaultForeGroundColor, StyledPropertyRow, StyledPropertyName, } from './styles';
export var renderDatasetSelect = function (_a) {
    var settings = _a.settings, datasets = _a.datasets, rulesDatasetId = _a.rulesDatasetId, onBulkSettingsChange = _a.onBulkSettingsChange, loadDataSetRule = _a.loadDataSetRule;
    var options = datasets === null || datasets === void 0 ? void 0 : datasets.map(function (dataset) { return ({
        value: dataset === null || dataset === void 0 ? void 0 : dataset.id,
        label: dataset === null || dataset === void 0 ? void 0 : dataset.name,
    }); });
    var handleOnSelect = function (option) {
        var _a, _b;
        var bulkObj = {
            datasetId: '',
        };
        if (option && (option === null || option === void 0 ? void 0 : option.value) !== rulesDatasetId) {
            loadDataSetRule(option.value);
        }
        var newValue = (_a = (option && option.value)) !== null && _a !== void 0 ? _a : '';
        bulkObj.datasetId = newValue;
        var tempSettings = __assign({}, settings);
        tempSettings.datasetId = newValue;
        if (((_b = tempSettings.datasetId) === null || _b === void 0 ? void 0 : _b.value) !== newValue) {
            bulkObj.ruleId = null;
            bulkObj.ruleVariables = [];
        }
        onBulkSettingsChange(bulkObj);
    };
    return (_jsx(Select, { options: options, placeholder: "Select a dataset...", value: (settings === null || settings === void 0 ? void 0 : settings.datasetId) &&
            (options === null || options === void 0 ? void 0 : options.find(function (option) { return (option === null || option === void 0 ? void 0 : option.value) === (settings === null || settings === void 0 ? void 0 : settings.datasetId); })), onChange: handleOnSelect, isClearable: true }));
};
export var renderDatasetRuleSelect = function (_a) {
    var _b, _c;
    var settings = _a.settings, onBulkSettingsChange = _a.onBulkSettingsChange, datasetRules = _a.datasetRules, datasetRulesLoading = _a.datasetRulesLoading, datasetRuleGroups = _a.datasetRuleGroups, datasets = _a.datasets, visibleCreateDialog = _a.visibleCreateDialog, setVisibleCreateDialog = _a.setVisibleCreateDialog, onSaveRule = _a.onSaveRule;
    var datasetRuleOptions = (settings === null || settings === void 0 ? void 0 : settings.datasetId)
        ? __spreadArray([
            {
                value: '-2',
                label: (_jsx(Button, __assign({ size: "small", block: true, type: "primary", onClick: function () { return setVisibleCreateDialog(true); } }, { children: "Add Rule" }))),
            }
        ], datasetRules === null || datasetRules === void 0 ? void 0 : datasetRules.map(function (rule) { return ({
            value: rule === null || rule === void 0 ? void 0 : rule.id,
            label: rule === null || rule === void 0 ? void 0 : rule.name,
            variables: rule === null || rule === void 0 ? void 0 : rule.variables,
        }); }), true) : [];
    // Find selected dataset's column names for use by the create rule dialog's column select dropdown
    var createRuleDialogDsColumnOptions = (_c = (_b = datasets.find(function (ds) { return (settings === null || settings === void 0 ? void 0 : settings.datasetId) === (ds === null || ds === void 0 ? void 0 : ds.id); })) === null || _b === void 0 ? void 0 : _b.fields) !== null && _c !== void 0 ? _c : [];
    return (_jsxs(_Fragment, { children: [_jsx(Modal, __assign({ open: visibleCreateDialog, onClose: function () { return setVisibleCreateDialog(false); } }, { children: _jsx(CreateRuleDialog, { groups: datasetRuleGroups, columns: createRuleDialogDsColumnOptions, onSaveClick: function (rule) {
                        setVisibleCreateDialog(false);
                        onSaveRule(rule);
                    }, isNotSystemDs: true }) })), _jsx(Select, { options: datasetRuleOptions, placeholder: "Select a dataset rule...", value: settings.ruleId &&
                    (datasetRuleOptions === null || datasetRuleOptions === void 0 ? void 0 : datasetRuleOptions.find(function (option) { return (option === null || option === void 0 ? void 0 : option.value) === (settings === null || settings === void 0 ? void 0 : settings.ruleId); })), onChange: function (option) {
                    var _a, _b;
                    if (option && option.value === '-2')
                        return;
                    onBulkSettingsChange({
                        ruleId: (_a = option === null || option === void 0 ? void 0 : option.value) !== null && _a !== void 0 ? _a : '',
                        ruleVariables: (_b = option === null || option === void 0 ? void 0 : option.variables) !== null && _b !== void 0 ? _b : [],
                    });
                }, isClearable: true, isDisabled: datasetRulesLoading })] }));
};
export var renderIconPicker = function (_a) {
    var icons = _a.icons, patch = _a.patch, handleIconChange = _a.handleIconChange;
    var icon = patch.settings.icon;
    return (_jsx(IconPopover, { icon: icon !== null && icon !== void 0 ? icon : faQuestion, onChange: function (value) {
            handleIconChange(value);
        }, color: defaultForeGroundColor, customIcons: icons }));
};
export var renderIOBinder = function (_a) {
    var _b;
    var settings = _a.settings, onSettingsChange = _a.onSettingsChange, output = _a.output;
    return (_jsxs(StyledPropertyRow, { children: [_jsxs(StyledPropertyName, { children: ['Target: ', _jsx("strong", { children: output === null || output === void 0 ? void 0 : output.label })] }), _jsx(Select, { options: output === null || output === void 0 ? void 0 : output.options, placeholder: "Select an input", value: (_b = output === null || output === void 0 ? void 0 : output.options) === null || _b === void 0 ? void 0 : _b.find(function (option) { return (option === null || option === void 0 ? void 0 : option.value) === settings[output === null || output === void 0 ? void 0 : output.name]; }), onChange: function (option) {
                    var _a;
                    onSettingsChange(output.name, (_a = (option && (option === null || option === void 0 ? void 0 : option.value))) !== null && _a !== void 0 ? _a : '');
                }, isClearable: true })] }, output === null || output === void 0 ? void 0 : output.name));
};
